import copy from 'copy-to-clipboard'

import { replaceNewLineEmojiAsString } from 'common/variantsUtils'

export const copyAndReplaceNewLineEmoji = (text) =>
  copy(replaceNewLineEmojiAsString(text))
